<div class="dialog" *ngIf="dialogShow">
  <p-dialog
    [showHeader]="false"
    (onHide)="cleanDialog()"
    (onShow)="openDialog()"
    [modal]="true"
    [(visible)]="dialogShow"
    [style]="{ width: '75%', height: '75%' }"
    [baseZIndex]="10000"
  >
    <i
      class="pi pi-times"
      style="font-size: 1rem"
      (click)="closeEventsWindow()"
    ></i>
    <p-tabView (onChange)="tabChange($event)">
      <p-tabPanel header="Eventos Recentes">
        <h3 class="text-center mb-2">Eventos de alertas dos últimos 30 minutos</h3>
        <p-table
        *ngIf="!notFoundLastAlerts"
        [lazy]="true"
        [value]="alerts"
        [paginator]="true"
        dataKey="id"
        [rows]="10"
        [totalRecords]="totalRecords"
        [(first)]="first"
        [tableStyle]="{ 'min-width': '50rem' }"
        currentPageReportTemplate="{first} - {last} de {totalRecords}"
        [showCurrentPageReport]="true"
        (onPage)="getDeviceAlerts($event, currentFilter)"
        [loading]="showSpinnerAlerts"
        >
          <ng-template pTemplate="header">
              <tr>
                  <!-- <th></th> -->
                  <th>Equipamento</th>
                  <th>Evento</th>
                  <th>Data</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-alert let-expanded="expanded">
            <tr>
              <!-- <td>
                <div [pRowToggler]="alert">
                  <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </div>
              </td> -->
              <td>
                <i class="fas fa-video mr-2"></i>
                {{ alert.equipamento.name+' - '+alert.endereco}}
              </td>
              <td class="font-semibold" [ngStyle]="{'color':getAlertColor(alert.statusEquipamentoDesc)}">{{ alert.observacao }}</td>
              <td>{{ alert.dataRegistro  | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr>
          </ng-template>
          <!-- <ng-template pTemplate="rowexpansion" style="width: 100%;" let-alert>
            <tr class="expanded-row">
              <td colspan="12">
                <div class="grid w-full scale-in-ver-top">
                  <div class="col-6 flex align-items-center">
                    <label class="text-lg">Endereço:&nbsp;</label>
                    <label class="font-semibold text-lg">{{alert.endereco}}</label>
                  </div>
                  <div class="col-6 flex align-items-center">
                    <label class="text-lg">Tipo de Evento:&nbsp;</label>
                    <label class="font-semibold text-lg">{{alert.tipoEventoEquipamentoDesc}}</label>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template> -->
        <!-- <div class="loading">
          <p-progressSpinner *ngIf="showSpinnerAlerts"></p-progressSpinner>
        </div> -->
        </p-table>
        <app-not-found-component
        *ngIf="notFoundLastAlerts"
        [titulo]="tituloNotFoundLastAlerts"
        [descricao]="descricaoNotFoundLastAlerts"
        ></app-not-found-component>
      </p-tabPanel>
      <p-tabPanel header="Eventos por Filtro">
        <div class="grid mt-3">
          <div class="col-4">
            <span class="p-float-label">
              <p-calendar
                [style]="stylePattern"
                selectionMode="range"
                [readonlyInput]="true"
                [maxDate]="maxDate"
                inputId="filterRange"
                [class]="!verifyVariables() ? 'ng-invalid ng-dirty' : ''"
                [(ngModel)]="rangeDates"
              ></p-calendar>
              <label htmlFor="filterRange">Intervalo</label>
            </span>
          </div>
          <div class="col-4">
            <span class="p-float-label">
              <p-multiSelect
                [(ngModel)]="alertFilter.eventType"
                panelStyleClass="dropdown-borders"
                [scrollHeight]="'15rem'"
                selectedItemsLabel="{0} tipos selecionados"
                [style]="stylePattern"
                [options]="eventsTypeOptions"
                inputId="filterEventType"
                optionValue="id"
                optionLabel="description"
                tooltipPosition="left"
                [filter]="true" [showClear]="true"
                placeholder="Selecione o tipo"
                >
               </p-multiSelect>
               <label htmlFor="filterEventType">Tipo de Evento</label>
            </span>
          </div>
          <div class="col-4 flex text-align: right;">
            <p-button
              [disabled]="(!verifyVariables() || rangeDates?.length==0 || rangeDates == undefined) || (alertFilter.eventType?.length==0 || !alertFilter.eventType)"
              class="block relative mr-2 top-100 -translate-y-100"
              [style]="{ height: '40px' }"
              label="Filtrar"
              (onClick)="getDeviceAlertsFiltered(false, alertFilter)"
              size="small"
              icon="pi pi-search"
            ></p-button>
            <p-button
              [disabled]="(alertFilter.eventType?.length==0 || !alertFilter.eventType)  && (rangeDates?.length==0 || rangeDates == undefined)"
              class="block relative top-100 -translate-y-100"
              [style]="{ height: '40px' }"
              label="Limpar Filtro"
              size="small"
              icon="pi pi-times"
              (onClick)="clearFilter()"
            ></p-button>
          </div>
        </div>
        <p-table
        *ngIf="!notFoundAlertsFiltered"
        [lazy]="true"
        [value]="alertsFiltered"
        [paginator]="true"
        dataKey="id"
        [rows]="10"
        [totalRecords]="alertTotalRecords"
        [(first)]="alertFirst"
        [tableStyle]="{ 'min-width': '50rem' }"
        currentPageReportTemplate="{first} - {last} de {totalRecords}"
        [showCurrentPageReport]="true"
        (onPage)="getDeviceAlertsFiltered($event, alertCurrentFilter)"
        [loading]="showSpinnerAlertsFiltered"
        >
          <ng-template pTemplate="header">
              <tr>
                  <!-- <th></th> -->
                  <th>Equipamento</th>
                  <th>Evento</th>
                  <th>Data</th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-alert let-expanded="expanded">
            <tr>
              <!-- <td>
                <div [pRowToggler]="alert">
                  <button type="button" pButton pRipple class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                </div>
              </td> -->
              <td>
                <i class="fas fa-video mr-2"></i>
                {{ alert.equipamento.name+' - '+alert.endereco}}
              </td>
              <td class="font-semibold" [ngStyle]="{'color':getAlertColor(alert.statusEquipamentoDesc)}">{{ alert.observacao }}</td>
              <td>{{ alert.dataRegistro  | date : "dd/MM/yyyy HH:mm:ss" }}</td>
            </tr>
          </ng-template>
          <!-- <ng-template pTemplate="rowexpansion" style="width: 100%;" let-alert>
            <tr class="expanded-row">
              <td colspan="12">
                <div class="grid w-full scale-in-ver-top">
                  <div class="col-6 flex align-items-center">
                    <label class="text-lg">Endereço:&nbsp;</label>
                    <label class="font-semibold text-lg">{{alert.endereco}}</label>
                  </div>
                  <div class="col-6 flex align-items-center">
                    <label class="text-lg">Tipo de Evento:&nbsp;</label>
                    <label class="font-semibold text-lg">{{alert.tipoEventoEquipamentoDesc}}</label>
                  </div>
                </div>
              </td>
            </tr>
          </ng-template> -->
        <!-- <div class="loading">
          <p-progressSpinner *ngIf="showSpinnerAlerts"></p-progressSpinner>
        </div> -->
        </p-table>
        <app-not-found-component
        *ngIf="notFoundAlertsFiltered"
        [titulo]="tituloNotFoundAlertsFiltered"
        [descricao]="descricaoNotFoundAlertsFiltered"
        ></app-not-found-component>
      </p-tabPanel>
    </p-tabView>
  </p-dialog>
</div>

<p-toast position="top-right" key="c"></p-toast>
<p-toast position="top-right" key="d"></p-toast>
